import { get } from "./requests";
import { URL_BASE } from "./constants";

export async function getAllStates() {
    const response = await get(`${URL_BASE}/states`);
    return response.data;
}